import { ICustomReportTemplateListItem } from '@/Interfaces/ReportBuilder/Template.interface';
import { Grid } from '@/components/Grid';
import { EXPAND_OPTIONS } from '@/constants/grid';
import {
  CustomReportTemplateDeleteFunction,
  CustomReportTemplateShareFunction,
} from '@/types/ReportBuilder/GridFunction.types';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { gridClasses } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import GridToolBar from '../Components/GridToolbar';
import { getColumns } from './columns';

interface IProps {
  data: ICustomReportTemplateListItem[];
  loading?: boolean;
  onShareTemplate: CustomReportTemplateShareFunction;
  onDeleteTemplate: CustomReportTemplateDeleteFunction;
}

const TemplateReportsGrid = ({ data, loading, onShareTemplate, onDeleteTemplate }: IProps) => {
  const columns = useMemo(() => getColumns({ onShareTemplate, onDeleteTemplate }), [onShareTemplate, onDeleteTemplate]);

  return (
    <Grid
      sx={{
        border: 'none',
        [`& .${gridClasses.main}`]: {
          borderBottom: '1px solid rgb(227, 227, 227)',
        },
        [`& .${gridClasses.columnHeaders}`]: {
          borderRadius: 0,
          borderTop: '1px solid rgb(227, 227, 227)',
        },
      }}
      columns={columns}
      loading={loading}
      autosizeOnMount
      autosizeOptions={EXPAND_OPTIONS}
      disableRowSelectionOnClick
      disableColumnFilter
      disableColumnMenu
      disableColumnSelector
      showCellVerticalBorder
      showColumnVerticalBorder
      rows={data}
      columnHeaderHeight={30}
      slots={{
        toolbar: GridToolBar,
        columnSortedAscendingIcon: KeyboardArrowUp,
        columnSortedDescendingIcon: KeyboardArrowDown,
      }}
      slotProps={{
        toolbar: {
          loading,
          title: 'Template Reports',
        },
        footer: {
          className: 'relative',
        },
      }}
    />
  );
};

export default TemplateReportsGrid;
